import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-contact-us-links',
    imports: [ButtonModule],
    templateUrl: './contact-us-links.component.html',
    styleUrl: './contact-us-links.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsLinksComponent {}
